import { render } from "./ApplicationLogo.vue?vue&type=template&id=26b07064"
const script = {}

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__